"use strict";

exports.__esModule = true;
exports.getProperty = exports.default = void 0;
var breakpoints = {
  xs: 420,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
function queries(size) {
  return "@media all and (max-width: " + breakpoints[size] + "px)";
}
function toTitleCase(string) {
  return string.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
}
var sizeOrder = ['sm', 'md', 'lg', 'xl'];
var getProperty = function getProperty(props, property, size) {
  if (props["" + size + toTitleCase(property)]) {
    return props["" + size + toTitleCase(property)];
  } else if (size === 'xl') {
    return props[property];
  }
  var index = sizeOrder.indexOf(size);
  return getProperty(props, property, sizeOrder[index + 1]);
};
exports.getProperty = getProperty;
var _default = queries;
exports.default = _default;